import { MetadataSerialization, RealTimeProperties } from '@adaptiva/metadata/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseAuthoringPropertiesComponent } from '../base-authoring-component';

@Component({
	standalone: false,
	selector: 'ada-real-time-properties',
	templateUrl: './real-time-properties.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class RealTimePropertiesComponent extends BaseAuthoringPropertiesComponent<RealTimeProperties> {

	public propertyConstructor: MetadataSerialization.Deserializable<RealTimeProperties> = RealTimeProperties;

}
